import http from "../http-common";

export default class {
  getLandingBanners(path: string) {
    let url = `/landing-banners?path=${path}`;

    return http.get(url);
  }
}